import React from 'react';
import Tile from '../ui/Tile';
import TileHeader from '../ui/TileHeader';
import { UserPlus, UserCog } from 'lucide-react';
import ClientFormDetails from './components/ClientFormDetails';
import ClientFormActions from './components/ClientFormActions';

const ClientForm = ({
  formData = {},
  handleInputChange = () => {},
  handleClientSubmit = () => {},
  isEditing = false,
  handleCancelEdit = () => {}
}) => {
  return (
    <form onSubmit={handleClientSubmit} className="w-full">
      <Tile>
        <TileHeader 
          title={isEditing ? 'Редактиране на клиент' : 'Нов клиент'} 
          icon={isEditing ? UserCog : UserPlus} 
        />
        <ClientFormDetails formData={formData} handleInputChange={handleInputChange} />
        <ClientFormActions isEditing={isEditing} handleCancelEdit={handleCancelEdit} />
      </Tile>
    </form>
  );
};

export default ClientForm;
